import { render, staticRenderFns } from "./IssueItem.vue?vue&type=template&id=5517181b&scoped=true"
import script from "./IssueItem.vue?vue&type=script&lang=js"
export * from "./IssueItem.vue?vue&type=script&lang=js"
import style0 from "./IssueItem.vue?vue&type=style&index=0&id=5517181b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5517181b",
  null
  
)

export default component.exports